import React from 'react';
import PropTypes from 'prop-types';

const SSOSigninSignUpForm = ({ data, locales }) => {
  let classroomShareRedirect = null;
  let establishmentId = null;
  let classroomSecret = null;
  let signupCode = null;

  if (data) {
    classroomShareRedirect = data.classroomShareRedirect;
    establishmentId = data.establishmentId;
    classroomSecret = data.classroomSecret;
    if (data.elevatedSignupInfo) {
      signupCode = data.elevatedSignupInfo.slug;
    }
  }

  const csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute('content');

  return (
    <>
      <form
        id="sso-form"
        action={`/ssousers/auth/azure_activedirectory_v2?classroom_secret=${classroomSecret}&establishment_id=${establishmentId}&redirect_url=${classroomShareRedirect}&signupCode=${signupCode}`}
        method="POST"
        className="sign-up-form"
      >
        <div
          className="sign-up-form__actions"
          style={{ justifyContent: 'center' }}
        >
          <button
            type="submit"
            value="Submit"
            className="bmc-button bmc-button--sign-up"
          >
            <div
              style={{
                gap: 0,
              }}
              className="sso-sign-up-form"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                style={{ marginLeft: '12px', marginRight: '12px' }}
              >
                <title>MS-SymbolLockup</title>
                <rect x="1" y="1" width="9" height="9" fill="#f25022" />
                <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
                <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
                <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
              </svg>
              <div
                style={{
                  pointerEvents: 'none',
                  marginRight: '12px',
                }}
              >
                {locales.common.signInWithMicrosoft}
              </div>
            </div>
          </button>
        </div>
        <input type="hidden" name="authenticity_token" value={csrfToken} />
      </form>
    </>
  );
};

SSOSigninSignUpForm.propTypes = {
  data: PropTypes.object,
};

export default SSOSigninSignUpForm;
